import {ReactNode} from "react";
import {DibJsonNode} from "../../types";
import {bffApi} from "../../../chat/bffApi";
import {useTranslation} from "react-i18next";
import {fileIconMap, fileExtensionMap, fileColorMap} from "../../contentUtils";
import DownloadIcon from "../../../../assets/download.svg?react";
import contentLinkClasses from "../contentLink.module.css";
import classes from "./file.module.css";

export const File = ({
    node,
    children,
}: {
    node: DibJsonNode;
    children: ReactNode[];
}) => {
    const {t} = useTranslation();
    const {data: userData} = bffApi.endpoints.getUser.useQueryState();
    const isDemo = !userData ? true : userData.demokonto;

    const data = node.object!.data as {
        topicId: string;
        topicName: string;
        resourceTypeId: number;
    };
    const resourceTypeId = String(data.resourceTypeId);
    const resourceId = data.topicId;
    const fileName = data.topicName;
    const extension = fileExtensionMap[resourceTypeId] ?? "";
    const Icon = fileIconMap[resourceTypeId];
    const iconColor = fileColorMap[resourceTypeId];

    const title = isDemo
        ? t("file.downloadNotForDemo")
        : t("file.download", {file: fileName});

    const href = isDemo
        ? undefined
        : `/dibapi/document/file?resourceId=${resourceId}`;

    return (
        <a
            href={href}
            download={`${fileName}${extension}`}
            title={title}
            className={`${contentLinkClasses.navLink} ${classes.fileLink} ${isDemo ? classes.disabled : ""}`}
            aria-disabled={isDemo || undefined}
        >
            {children}
            {Icon && (
                <>
                    <Icon
                        className={classes.icon}
                        style={iconColor ? {color: iconColor} : undefined}
                        aria-hidden
                    />
                    <DownloadIcon className={classes.downloadIcon} aria-hidden />
                </>
            )}
        </a>
    );
};
